import { useRouter } from 'next/router';

import { isMobile } from '@src/helpers/isMobileDevice';
import {
  fullDealLandingPageRoute,
  kazakhstanSeoListRoutes,
  kzContextPageRoute,
} from '@src/shared/constants/pageRoutes';

export const useHasOfferFix = () => {
  const router = useRouter();

  return {
    getIsEnableRedirectToFullDeal: () => {
      const kzRoutes = [...kazakhstanSeoListRoutes, kzContextPageRoute];

      if (isMobile() && !kzRoutes.some((route) => router.asPath.startsWith(route))) {
        return true;
      }

      return false;
    },
    navigateToFullDealLandingPage: () => {
      router.push(fullDealLandingPageRoute);
    },
  };
};
